import request from '@/utils/request'

// 获取可购买的套餐列表
export function getSalesPackage(data) {
    return request({
        url: '/api/common/v1/order/getSalesPackage',
        method: 'post',
        data
    })
}

// 获取当前租户套餐包剩余数量
export function getUserPackageSurplus(data) {
    return request({
        url: '/api/common/v1/order/getUserPackageSurplus',
        method: 'post',
        data
    })
}

// 创建订单
export function createOrder(data) {
    return request({
        url: '/api/common/v1/order/add',
        method: 'post',
        data
    })
}

// 获取支付页面
export function payForOrder(data) {
    return request({
        url: '/api/common/v1/order/getPayPage',
        method: 'post',
        data
    })
}

// 获取支付页面
export function getOrderByOrderId(data) {
    return request({
        url: '/api/common/v1/order/getOrderByOrderId',
        method: 'post',
        data
    })
}
